import getMyCarsVehicleFromVinOrId from '../../utils/getMyCarsVehicleFromVinOrId';
import getInventoryType from '../../utils/getInventoryType';

export const DDC_LINK_MYCARSCOMPARESUBMIT = 'ddc.link.mycarsCompareSubmit';

function mycarsCompareSubmit(
	{
		DDC: {
			dataLayer: { myCars }
		}
	},
	{ currentTarget: element }
) {
	const ids = $(element)
		.closest('.popup')
		.find('.item-compare .checkbox:checked')
		.map((_index, checked) => $(checked).val())
		.get();

	const vehicles = ids.map((id) => {
		const vehicle = getMyCarsVehicleFromVinOrId(id, myCars);
		return {
			vin: vehicle.vin,
			make: vehicle.make,
			model: vehicle.model,
			year: vehicle.year,
			trim: vehicle.trim,
			condition: getInventoryType(vehicle) || ''
		};
	});

	return {
		eventType: DDC_LINK_MYCARSCOMPARESUBMIT,
		eventData: {
			element,
			vehicles
		}
	};
}

export default mycarsCompareSubmit;
